import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
  urlHome: boolean = true;
  lang: string;

  constructor(private base: BaseService) { }

  ngOnInit() {
    var body = $("html, body");
    this.lang = this.base.getLang();
    body.stop().animate({ scrollTop: 0 }, 500, "swing");
    $(".nav-item").removeClass("active");
    $("#home").addClass("active");
    $(window).on("scroll", function () {
      if ($(".Business").offset() != undefined) {
        if (
          $(window).scrollTop() >=
          parseInt($(".Business").offset().top) - 300
        ) {
          AnimSVG();
        }
      }
    });

    function AnimSVG() {
      var namePublic = "#services-item";

      var i;
      for (i = 1; i < 6; i++) {
        AnimSVGShape(namePublic + i, i);
      }
    }

    function AnimSVGShape(name, i) {
      setTimeout(function () {
        $(name).animate(
          {
            opacity: "1"
          },
          300
        );
        if (i >= 2) {
          AnimSVGNum(name, i);
        } else {
          AnimSVGLogo(name, i);
        }
      }, parseInt(i + "00") - 10);
    }

    function AnimSVGNum(name, i) {
      $(name + "-num").animate(
        {
          opacity: "1"
        },
        500
      );
      AnimSVGLogo(name, i);
    }

    function AnimSVGLogo(name, i) {
      $(name + "-logo").animate(
        {
          opacity: "1"
        },
        600
      );
      AnimSVGText(name, i);
    }

    function AnimSVGText(name, i) {
      $(name + "-text").animate(
        {
          opacity: "1"
        },
        700
      );
    }

    function link(name, lang) {
      var url = "";
      if (lang == "ar") {
        url = "services-ar.html#" + name;
      } else {
        url = "services.html#" + name;
      }
      // window.location = url;
    }
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
  }
  
  onLoading(id) {
    $("#" + id).fadeOut("fast");
  }

  ngOnDestroy(): void {
    this.urlHome = false;
  }
}
